import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Images from "assets/images/imageData";
import Layout from "components/layout/Layout";
import localization from "assets/localization/localization";
import callWebService, { callTypes } from "services/utils/networks/network";
import DropDownFilter from "components/input/dropdown/dropDownFilter";
import "./EMudra.scss";
import {
  checkEmpty  
} from "services/utils/commonFunctions/CommonFunctions";
import Config from "services/config/config";
import { trim } from "lodash";
import CustomModal from "components/modal/modal";
import CopyPaste from "components/copypaste/Copypaste";
import { BaseUrl } from "context/baseUrl/baseUrl";
import FormSection from "components/form/FormSection";
import Loader from "components/loader/loader";
import MainLayout from "components/mainLayout/MainLayout";
import JsonFormatter from "react-json-formatter";
import DropdownFilter from "components/input/dropdown/dropDownFilter";

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';

const TagsInput = props => {
	const [tags, setTags] = React.useState(props.tags);
	const removeTags = indexToRemove => {
		setTags([...tags.filter((_, index) => index !== indexToRemove)]);
    props.selectedTags([...tags.filter((_, index) => index !== indexToRemove)]);
	};

	const addTags = event => {    
		if (event.target.value !== "" && event.target.value.length >= 2 ) {
      const checkAvailable = tags.includes(event.target.value);
      if (!checkAvailable) {
        setTags([...tags, event.target.value]);
        props.selectedTags([...tags, event.target.value]);
        event.target.value = "";
        props.enterBtn();
      }
		}
	};

  const pasteNotAllow = (e) => {
    e.preventDefault();
    return false;
  }

	return (
		<div className="tags-input">
			<ul id="tags">
				{tags.map((tag, index) => (
					<li key={index} className="tag">
						<span className='tag-title'>{tag}</span>
						<span className='tag-close-icon'
							onClick={() => removeTags(index)}
						>
							x
						</span>
					</li>
				))}
			</ul>
			<input
				type="text"
        name="finType"
        autoComplete="off"
        maxLength={20}
        onPaste={(e) => pasteNotAllow(e)}
        minLength={2}
        value={props.data || ""}
        className="search-button"
				onKeyUp={event => event.key === "Enter" ? addTags(event) : null}
        onChange={(e) => props.finTypeChange(e)}
				placeholder="Press enter to add FinType"
			/>
		</div>
	);
};


const EMudra = ({ match }) => {
  const selectedTags = tags => {
    setFinTypeCheck(tags)
	};

  const [isCheck, setIsCheck] = useState([]);
  const [smallModal, setSmallModal] = useState({hover1: false, hover2: false, show: false});
  const [modalShow, setModalShow] = useState(false);
  const [activeComponent, setActiveComponent] = useState();
  const [isLoading, setisLoading] = useState(false);
  const [applicationCode, setApplicationCode] = useState("");
  const [response, setResponse] = useState(null);
  const [request, setRequest] = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [perPageRecord, setPerPageRecord] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [emudraList, setEmudraList] = useState([]);

  const [enterBtn, setEnterBtn] = useState(true);

  const scrl = useRef(null);

  const [show, setShow] = useState(false);
  const [finTypeCheckbox, setDocFormatCheckboc] = useState([]);
  const [finTypeCheck, setFinTypeCheck] = useState([]);
  const [signLabel, setSignLabel] = useState([]);
  const [finTypeChip, setFinTypeChip] = useState([]);

  const [errorMsg, setErrorMsg] = useState("");
  const [isEditFinType, setIsEditFinType] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [addFinTypeData, setAddFinTypeData] = useState({
    id: "",
    name: "",
    finType: "",
    signLabel: "",
  });

  const [editDmsData, setEditDmsData] = useState({});
  const [errMsg, setErrMsg] = useState({
    name: "",
    signLabel: "",
    finType: ""
  });

  useEffect(()=>{
    (async () => {
      finTypeList();
      eMudraApi(1);
   })();
  },[])

  const eMudraApi = async (page, handleRecordPerPage) => {
    setisLoading(true);
    const data={
      pageSize: handleRecordPerPage ? handleRecordPerPage : perPageRecord,
      pageNo: page ? page : 1,
      searchName: applicationCode ? trim(applicationCode) : "",
    }

    const res = await callWebService(
      callTypes.post,
      data,
      Config.finTechType
    );
    if (res?.data?.data?.fintype_list) {
      setEmudraList(res?.data?.data?.fintype_list);
      setPerPageRecord(res?.data?.data?.pagination?.pre_page_records);
      setTotalRecord(res?.data?.data?.pagination?.total_rows);
      setPageNo(page ? page : res?.data?.data?.pagination?.current_page);
      setisLoading(false);
    }
  }

  const finTypeList = async () => {

    const res = await callWebService(
      callTypes.post,
      null,
      Config.finTypes
    );
    const finArray = [];
    const signArray = [];
    const finTypeData = res?.data?.successData?.successResponse?.fintype;
    const signlabelData = res?.data?.successData?.successResponse?.signlabel;
    if (finTypeData) {
      finTypeData.filter(f =>f !== null).forEach(f => {
        let obj = {
          name: f,
          id: f
        }
        finArray.push(obj);
      })
      setDocFormatCheckboc(finArray);
    }
    if (signlabelData) {
      signlabelData.forEach(f => {
        let obj = {
          name: f,
          id: f
        }
        signArray.push(obj);
      })
      setSignLabel(signArray);
    }
  }

  const renderHeader = () => {
    let headerElement = [
      "S. No.",
      "Name",
      "FinType",
      "Sign Label",
      "Action"
    ];

    return headerElement.map((key, index) => {
      return <th key={index}>{key}</th>;
    });
  };

    //edit emudra
    const editEmudra = (data) => {
      const dataArray = [];
      setShow(true);
      setIsEditFinType(true)
      setEditDmsData(data)
      const dataObj = {
        id: data.id,
        finType: "",
        name: data.name,
        signLabel: data.sign_label,
      }
      setAddFinTypeData(dataObj);
      data?.fin_type.forEach((f, idx) => {
        dataArray.push(f);
      });
      setFinTypeCheck(dataArray);
    }

  const closeModal = () => {
    setModalShow(false);
    setResponse("");
    setRequest("");
  };

  const testJSON = (text) => {
    if (typeof text !== "string") {
      return false;
    }
    try {
      var json = JSON.parse(text);
      return json;
    } catch (error) {
      return false;
    }
  };

  const jsonStyle = {
    propertyStyle: { color: "red" },
    stringStyle: { color: "green" },
    numberStyle: { color: "darkorange" },
  };

  const recordsPerPage = [
    { records_id: 10, records_value: 10 },
    { records_id: 20, records_value: 20 },
    { records_id: 30, records_value: 30 },
    { records_id: 50, records_value: 50 },
  ];

  const renderBody = () => {  
   
    return (
      !checkEmpty(emudraList) &&
      emudraList.map((val, index) => {
        return (
          <tr key={index}>
            <td>{pageNo === 1 ? index + 1 : (pageNo - 1) * perPageRecord + index + 1 }</td>       
            <td>{val.name}</td>
            <td>
              {
                 val?.fin_type && val?.fin_type.map((d, index) => (
                  <React.Fragment key={index}>
                  {index && (index+1)%10 == 0 ? <br/> : ""}
                  <span className="badge badge-pill badge-dark mr-1">{d}</span></React.Fragment> 
                ))
              }
            </td>
            <td>{val.sign_label}</td>  
            <td>
              <Link
                  to="#"
                  onClick={() => editEmudra(val)}
                >
                <img src={Images?.editBtn} alt="" width={20}/>
                </Link>&nbsp;
                  <Link
                    to={{
                      pathname: `/finType-history/${val.id}`
                    }}
                  >
                    <img src={Images?.eyeIcon} alt="" width={20}/>
                  </Link>
            </td>       
          </tr>
        );
      })
    );
  };

  const nextPage = async (page) => {
    setisLoading(true);
    eMudraApi(page);
    setisLoading(false);
  }

  const handleRecordsPerPage = async (event) => {
    setPageNo(1);
    setisLoading(true);
    eMudraApi(1, parseInt(event.target.value));
  };

  const handleClose = () => {
    setAddFinTypeData({
      name: "",
      signLabel: "",
      finType: "",
      id: "",
    });
    setErrMsg({
      name: "",
      signLabel: "",
      id: "",
      finType: ""
    });
    setFinTypeCheck([])
    setIsEditFinType(false)
    setShow(false);
    setSuccessMsg("");
    setErrorMsg("");
  }

  const finTypeChange = (e) => {
    const { name, value } = e.target;

      if (name == "name" && value.length < 2) {
        setErrMsg((state) => ({ ...state, name: "Enter minimum 2 & maximum length 50" }));
        } else {
        setErrMsg((state) => ({ ...state, name: "", finType: "" }));
      } 
        
        if (name == "finType" && value.length < 2) {
          setEnterBtn(false);
          setErrMsg((state) => ({ ...state, finType: "Enter minimum 2 & maximum length 20" }));
          // setErrMsg((state) => ({ ...state, finType: "Press Enter to add FinType" }));
          } else if (name == "finType" ) {
          setErrMsg((state) => ({ ...state, finType: "Press Enter to add FinType" }));
        }

    setAddFinTypeData((state) => ({ ...state, [name]: value.trimStart().replace(/[^a-zA-Z0-9 ]/,"") }));
  }

  const handleShow = () => setShow(true);
  

  const handleSubmit = async () => {
    const nameRegex = /^[^-\s][a-zA-Z0-9_\s-]+$/;

    if (addFinTypeData.name === '' ) {
      setErrMsg((state) => ({ ...state, name: "Enter minimum 2 & maximum length 50" }));
      return;
    } else {
      setErrMsg((state) => ({ ...state, name: "" }));
    }

    if (finTypeCheck == 0 || addFinTypeData.finType != "") {
      setErrMsg((state) => ({
        ...state,
        finType: addFinTypeData.finType != "" ? "Press enter to add FinType" : "Enter minimum 2 & maximum length 50" ,
      }));
      return;
    } else {
      setErrMsg((state) => ({ ...state, finType: "" }));
    }
    
    if (addFinTypeData.signLabel === '') {
      setErrMsg((state) => ({ ...state, signLabel: "Enter sign label name" }));
      return;
    } else {
      setErrMsg((state) => ({ ...state, signLabel: "" }));
    }

    const userName = localStorage.getItem('username');
    const dataObj = {
      name: addFinTypeData.name?.trim(),
      type: finTypeCheck,
      signLabel: addFinTypeData.signLabel,
      id: addFinTypeData.id,
      actionType: isEditFinType ? "edit" : "add",
      username: userName,
    }
    setIsSubmit(true);
    const resData = await callWebService(
      callTypes.post,
      dataObj,
      Config.insertFinType
    );

    if (resData.data.status === true) {  
      setErrorMsg("");
      setSuccessMsg(resData.data.message);
      setAddFinTypeData({
        name: "",
        signLabel: "",
        finType: "",
        id: "",
      });
      setErrMsg({
        name: "",
        signLabel: "",
        finType: ""
      });
      setFinTypeCheck([]); 
      setIsSubmit(false);
      setTimeout(() => {
        document.location.reload();
      }, 500)
    } else {
      setIsSubmit(false);
      setSuccessMsg("");
      setErrorMsg(resData.data.message);
    }
  }
  const inputSearch = () => {
    return (
      <>
        <div style={{ float: "right", position: "relative" }}>
          {emudraList && emudraList.length > 0 ? (
            <b
              className="pagination-value"
              data-hovered={smallModal.hover1}
              style={{ cursor: "pointer" }}
              onMouseLeave={() => {
                setSmallModal({ ...smallModal, hover1: false, hover2: false });
              }}
              onMouseEnter={() => {
                setSmallModal({ ...smallModal, hover1: true, show: true });
              }}
            >
              {pageNo == 1 ? pageNo : (pageNo - 1) * perPageRecord + 1}-
              {pageNo * perPageRecord > totalRecord
                ? totalRecord
                : pageNo * perPageRecord}{" "}
              of {totalRecord}
            </b>
          ) : (
            <span className="pagination-value">0 - 0 of 0</span>
          )}
          &nbsp;
          {smallModal.hover1 && (
            <div
              className="small-modal"
              onMouseEnter={() => {
                setSmallModal({ ...smallModal, hover2: true });
              }}
              onMouseLeave={() => {
                setSmallModal({ ...smallModal, hover2: false, hover1: false });
              }}
            >
              <span
                className="small-modal-option"
                data-disabled={pageNo === 1 && true}
                onClick={() => {
                  nextPage(1);
                }}
              >
                Newest
              </span>
              <span
                className="small-modal-option"
                data-disabled={totalRecord <= pageNo * perPageRecord && true}
                onClick={() => {
                  nextPage(Math.ceil(totalRecord / perPageRecord));
                }}
              >
                Oldest
              </span>
            </div>
          )}
          <button
            className="pagination-button"
            onClick={() => nextPage(pageNo - 1)}
            title="Newer"
            data-disabled={pageNo <= 1 && true}
            disabled={pageNo <= 1}
          >
            {"<"}
          </button>
          &nbsp;
          <button
            className="pagination-button"
            onClick={() => nextPage(pageNo + 1)}
            title="Older"
            data-disabled={
              totalRecord <= pageNo * perPageRecord || emudraList.length === 0
            }
            disabled={
              totalRecord <= pageNo * perPageRecord || emudraList.length === 0
            }
          >
            {">"}
          </button>
        </div>
        &nbsp;&nbsp;
      &nbsp;<button style={{float:"right"}} className="btn btn-primary mr-2" onClick={()=> handleShow()} >Add </button> &nbsp; &nbsp;
      </>
    );
  };
  const filterSearch = () => {};

  const enterBtnFunction = () => {
    setAddFinTypeData((state) => ({ ...state, finType: "" }));
  }

  return (
    <BaseUrl.Provider value={{ baseUrl: match.url }}>
      <MainLayout activeComponent={activeComponent} match={match}>
        <Layout
          title="E Mudra List"
          isLoading={false}
          isGoback={true}
          className={"desktop-view"}
        >
          
          <FormSection
            search={true}
            inputSearch={inputSearch}
            filterSearch={filterSearch}
            sortBy={() => {}}
            isCheck={isCheck}
          >
            <div
              className="panel-card-table"
              ref={scrl}
              style={{ width: "100%", overflow: "auto" }}
            >
              <table id="employee" className="table table-bordered">
                <thead>
                  <tr>{renderHeader()}</tr>
                </thead>
                <tbody>{renderBody()}</tbody>
              </table>
            </div>
            <div style={{maxWidth: '150px'}}>
              <DropdownFilter o
                  ptIdKey="records_id"
                  optValueKey="records_value"
                  optionList={recordsPerPage}
                  placeholder="Records Per Page"
                  onChange={(event) => {
                    setPerPageRecord(event.target.value);
                    handleRecordsPerPage(event);
                  }}
                  value={perPageRecord}
               />
            </div>
          </FormSection>
          {modalShow && (
            <CustomModal
              show={modalShow}
              modalClose={closeModal}
              showHeader
              backdrop
            >
              <div className="modal-body chekdisplay">
                <div
                  className={
                    response !== "notification"
                      ? "panel-card panelcard"
                      : "panel-card"
                  }
                >
                  <div className="panel-heading pop">
                    {response !== "notification" ? (
                      <>
                        Request
                        <div style={{ float: "right" }}>
                          <CopyPaste data={request} />
                        </div>
                      </>
                    ) : (
                      "Notification Content"
                    )}
                  </div>
                  <div className="panel-body  mx-0 pop ">
                    <div className="panel-card-table ">
                      <div className="popupclass">
                        {testJSON(
                          request
                            ? request.toString().replace(/\\/g, "")
                            : "null"
                        ) ? (
                          <JsonFormatter
                            json={
                              request
                                ? request.toString().replace(/\\/g, "")
                                : "null"
                            }
                            tabWith={4}
                            jsonStyle={jsonStyle}
                          />
                        ) : request ? (
                          request.toString().replace(/\\/g, "")
                        ) : (
                          "null"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {response !== "notification" ? (
                  <div className="panel-card panelcard">
                    <div className="panel-heading pop">
                      Response
                      <div style={{ float: "right" }}>
                        <CopyPaste data={response} />
                      </div>
                    </div>
                    <div className="panel-body mx-0 pop ">
                      <div className="panel-card-table">
                        <div className="popupclass">
                          {testJSON(
                            response
                              ? response.toString().replace(/\\/g, "")
                              : "null"
                          ) ? (
                            <JsonFormatter
                              json={
                                response
                                  ? response.toString().replace(/\\/g, "")
                                  : "null"
                              }
                              tabWith={4}
                              jsonStyle={jsonStyle}
                            />
                          ) : response ? (
                            response.toString().replace(/\\/g, "")
                          ) : (
                            "null"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            </CustomModal>
          )}
          <Loader isLoading={isLoading} />
          <Modal className="dms-modal" show={show} onHide={handleClose}>
        <Modal.Header closeButton style={{backgroundColor: "#f7fcfd"}}>
          <Modal.Title >{isEditFinType ? "Edit" : "Add" } FinType
            <br/><span style={{color: successMsg ? "green" : "red", fontSize: "small"}}>{successMsg ? successMsg : errorMsg}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{textAlign: ""}}>
              <Col>
                <label>Enter Name</label>
                  <input
                    type="text"
                    maxLength={50}
                    minLength={2}
                    name="name"
                    className="search-button dms-search mt-2"
                    placeholder="Name..."
                    // onkeypress="return /[0-9a-zA-Z]/i.test(event.key)"
                    onChange={(e) => finTypeChange(e)}
                    // onKeyUp={(e) => finTypeChange(e)}
                    value={addFinTypeData.name || ""}
                  />  
                <span style={{color:"red"}}>{errMsg.name}</span>
              </Col>
              <Col>
                <label className="mb-2 mt-2">FinType </label>
                  <TagsInput selectedTags={selectedTags} 
                    finTypeChange={finTypeChange} 
                    data={addFinTypeData.finType} 
                    // tags={finTypeCheck.map((f) => f.name)}
                    tags={finTypeCheck}
                    enterBtn={enterBtnFunction}
                  />
                <span style={{color:"red"}}>{errMsg.finType}</span>
              </Col>
              <Col>
                <label className="mt-2">Sign Label</label>
                <DropDownFilter
                  value={addFinTypeData.signLabel || ""}
                  name="signLabel"
                  optionList={signLabel}
                  optIdKey="id"
                  optValueKey="name"
                  placeholder="Sign Label"
                  onChange={finTypeChange}
                />
                <span style={{color:"red"}}>{errMsg.signLabel}</span>
              </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            {isSubmit ? 'Loading...' : 'Submit' }
          </Button>
        </Modal.Footer>
      </Modal>
        </Layout>
        <div className="mobile-view container">
          <h3>{localization.label.myLead}</h3>
          <div className="my-lead-wrap">
            {/* {!checkEmpty(dataList) &&
              dataList.map((data, index) => (
                <ApplicationBox data={data} key={index} history={history} />
              ))} */}
          </div>
        </div>
      </MainLayout>
    </BaseUrl.Provider>
  );
};

export default EMudra;
